import React from 'react';
import PropTypes from 'prop-types';

import { data as agreementDataPropTypes } from '../agreementPropTypes.js';
import partnerPropTypes from '../partnerPropTypes.js';
import formatOreToKroner from '../../lib/formatOreToKroner.js';
import Separator from './separator.jsx';

const DiscountSuggestionDetailsForBuyer = ({
    agreement,
    discount,
    discountFee,
    newAmount,
    newFreight,
    partner,
    totalDiscount,
}) => (
    <div>
        <div className="line r-mts">
            <div className="unit size2of3">Avslag på pris</div>
            <div className="unit size1of3 rightify">
                - {formatOreToKroner(discount)}
            </div>
        </div>

        <div className="line r-mts">
            <div className="unit size2of3">Avslag på gebyr til FINN</div>
            <div className="unit size1of3 rightify">
                - {formatOreToKroner(discountFee)}
            </div>
        </div>

        <div className="line r-mtm">
            <div className="unit size2of3 strong">Du får tilbake</div>
            <div className="unit size1of3 rightify strong">
                {formatOreToKroner(totalDiscount)}
            </div>
        </div>

        <Separator />

        <h3 className="mln r-mtl">Du betaler</h3>

        <div className="line r-mts">
            <div className="unit size2of3">Total til {partner.name}</div>
            <div className="unit size1of3 rightify">
                {formatOreToKroner(newAmount + newFreight)}
            </div>
        </div>

        <div className="line r-mts">
            <div className="unit size2of3">Gebyr til FINN</div>
            <div className="unit size1of3 rightify">
                {formatOreToKroner(agreement.fee - discountFee)}
            </div>
        </div>

        <div className="line r-mtm">
            <div className="unit size2of3 strong">Sum</div>
            <div className="unit size1of3 rightify strong">
                {formatOreToKroner(
                    newAmount + newFreight + agreement.fee - discountFee
                )}
            </div>
        </div>
    </div>
);

DiscountSuggestionDetailsForBuyer.propTypes = {
    agreement: agreementDataPropTypes.isRequired,
    discount: PropTypes.number.isRequired,
    discountFee: PropTypes.number.isRequired,
    newAmount: PropTypes.number.isRequired,
    newFreight: PropTypes.number.isRequired,
    partner: partnerPropTypes.isRequired,
    totalDiscount: PropTypes.number.isRequired,
};

const DiscountSuggestionDetailsForSeller = ({
    discount,
    newAmount,
    newFreight,
}) => (
    <div className="mbl">
        <div className="line r-mts">
            <div className="unit size2of3">Avslag på pris</div>
            <div className="unit size1of3 rightify">
                - {formatOreToKroner(discount)}
            </div>
        </div>

        <Separator />

        <div className="line r-mts">
            <div className="unit size2of3 t3">Du får</div>
            <div className="unit size1of3 rightify strong">
                {formatOreToKroner(newAmount + newFreight)}
            </div>
        </div>
    </div>
);

DiscountSuggestionDetailsForSeller.propTypes = {
    discount: PropTypes.number.isRequired,
    newAmount: PropTypes.number.isRequired,
    newFreight: PropTypes.number.isRequired,
};

const DiscountSuggestionDetails = ({
    agreement,
    partner,
    role,
    discount,
    discountFee,
}) => {
    const newAmount = Math.max(0, agreement.amount - discount);
    const newFreight =
        agreement.amount - discount < 0
            ? agreement.freight + (agreement.amount - discount)
            : agreement.freight;
    const isBuyer = role === 'BUYER';
    const totalDiscount = isBuyer ? discount + discountFee : discount;

    return (
        <div>
            <Separator />

            <h3 className="mln r-mtl">Forslag</h3>

            <div className="r-mtm">
                {isBuyer ? (
                    <DiscountSuggestionDetailsForBuyer
                        agreement={agreement}
                        discount={discount}
                        discountFee={discountFee}
                        newAmount={newAmount}
                        newFreight={newFreight}
                        partner={partner}
                        totalDiscount={totalDiscount}
                    />
                ) : (
                    <DiscountSuggestionDetailsForSeller
                        discount={discount}
                        newAmount={newAmount}
                        newFreight={newFreight}
                    />
                )}
            </div>
        </div>
    );
};

DiscountSuggestionDetails.propTypes = {
    agreement: agreementDataPropTypes.isRequired,
    discount: PropTypes.number.isRequired,
    discountFee: PropTypes.number.isRequired,
    partner: partnerPropTypes.isRequired,
    role: PropTypes.oneOf(['BUYER', 'SELLER']).isRequired,
};

export default DiscountSuggestionDetails;



// WEBPACK FOOTER //
// ./safeTrade/resolution/discountSuggestionDetails.jsx